module.exports = __webpack_public_path__ + "static/media/butterfly.eb3d623e.png";